'use strict'

import modal from 'Modules/modal'
import cleanTextOnFocus from 'Modules/cleanTextOnFocus'
import validationForm from 'Modules/validationForm'

const J_FORM_NEWSLETTER = '.j_form_newsletter_popin'
const J_EMAIL_INPUT = 'input[name="j_email_popin"]'
const J_ACTION_DATA = 'action'
const C_input = '.newsletter-popup__container'
const C_remerciement = '.newsletter-popup__remerciement'
const C_abtCloseButton = 'abtmodal-newsletter-close'
const C_GREEN = 'green'
const C_RED = 'red'
const C_BLACK = 'black'

function ouvrirModalNewsletter() {
    modal.creer(
        'modal-newsletter',
        'modal-newsletter-size',
        window.location.origin + '/layout/GetNLModal',

        function () {
            cleanTextOnFocus.setEvent()

            $(J_FORM_NEWSLETTER).on('submit', function (event) {
                event.preventDefault()

                const form = $(this)

                validationForm.process(
                    function (content) {
                        // Callback de réussite
                        $(J_EMAIL_INPUT).val(content.Message)
                        cleanTextOnFocus.setEventOnCustomText(content.Message)
                        manageStyleForNewsletterError(content.CssClass)
                        document.querySelector(C_input).style.display = 'none'
                        document.querySelector(C_remerciement).style.display = 'block'
                        // suppression du tracking de fermeture sur AB Tasty
                        document.querySelectorAll('.'+C_abtCloseButton).forEach(element => {
                            element.classList.remove(C_abtCloseButton)
                        })
                    },
                    function (content) {
                        // Callback d'échec
                        $(J_EMAIL_INPUT).val(content.Message)
                        cleanTextOnFocus.setEventOnCustomText(content.Message)
                        manageStyleForNewsletterError(content.CssClass)
                    },
                    function (msg) {
                        // Callback pour email invalide
                        const content = {
                            Error: true,
                            CssClass: C_RED,
                            Message: msg
                        }
                        $(J_EMAIL_INPUT).val(content.Message)
                        cleanTextOnFocus.setEventOnCustomText(content.Message)
                        manageStyleForNewsletterError(content.CssClass)
                    },
                    $(form).data(J_ACTION_DATA),
                    form
                )
            })
        }
    )
}
/*
 * Gère les styles CSS à appliquer au champ newsletter selon le message
 */
function manageStyleForNewsletterError(cssClass) {
    $(J_EMAIL_INPUT).addClass(cssClass)
}

/*
 * Efface les couleurs des champs emails au focus
 */
$(J_EMAIL_INPUT).on('focus', function () {
    $(this).removeClass([C_GREEN, C_BLACK, C_RED])
})

export default {
    ouvrirModalNewsletter: ouvrirModalNewsletter
}
